import { render, staticRenderFns } from "./ServiceRequestsComp.vue?vue&type=template&id=ff6b1c26&scoped=true&"
import script from "./ServiceRequestsComp.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestsComp.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestsComp.vue?vue&type=style&index=0&id=ff6b1c26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6b1c26",
  null
  
)

export default component.exports